module.exports = __webpack_public_path__ + "static/media/suit.12b46e2f.svg";